export default {
  color: {
    primary: "#2886A6",
    success: "#73B68F",
    danger: "#bf5b56",
    warning: "#e69839",
    black: {
      o100: "rgba(37,42,43,1)",
      o80: "rgba(37,42,43,0.8)",
      o50: "rgba(37,42,43,0.5)"
    },
    white: {
      o100: "rgba(255,255,255,1)",
      o80: "rgba(255,255,255,0.8)",
      o50: "rgba(255,255,255,0.5)"
    },
    darkGray: "#515555",
    gray: "#717475",
    lightGray: "#929495",
    white1: "#E0E0E1",
    white2: "#B6B8B8",
    white3: "#979A9A",
    blueGradient: "linear-gradient(-180deg, #32A7CF 0%, #2886A6 100%)"
  },
  layers: {
    l1: "none",
    l2: "0 2px 4px 0 rgba(37,42,43,0.15)",
    l3: "0 6px 10px 0 rgba(37,42,43,0.15)",
    l4: "0 8px 16px 0 rgba(37,42,43,0.15)",
    l5: "0 12px 30px 0 rgba(37,42,43,0.15)"
  },
  fonts: {}
};



// WEBPACK FOOTER //
// ./src/styles/baseStyles.js